import { useState } from 'react';
import { useLocale, useT } from '../i18n';
import { useApiData } from '../api/useApiData';
import { contentApi } from '../api/content';
import AsyncSection from '../components/shared/AsyncSection';
import MethodologyOrbit from '../components/shared/MethodologyOrbit';

interface StageContent {
  n: number;
  code: string;
  lines: string[];
  stage: string;
  question: string;
  deliverable: string;
}

export default function Methodology() {
  const locale = useLocale();
  const t = useT();
  const state = useApiData(() => contentApi.page('methodology', locale), [locale]);
  const [active, setActive] = useState<string>((window.location.hash || '#assess').replace('#', ''));

  return (
    <section className="section" style={{ paddingTop: 160 }}>
      <div className="container">
        <div className="section-head center reveal is-visible">
          <span className="eyebrow">{t('home.engine_eyebrow')}</span>
          <h1>{t('home.engine_headline')}</h1>
          <p>{t('home.engine_quote')}</p>
        </div>
        <AsyncSection
          state={state}
          render={(page) => {
            const stages: StageContent[] = ((page.contentBlocks as any)?.stages ?? []).map((s: any) => ({
              n: s.n,
              code: s.code,
              lines: s.lines ?? [],
              stage: s.t?.[locale]?.stage ?? s.stage,
              question: s.t?.[locale]?.question ?? s.question,
              deliverable: s.t?.[locale]?.deliverable ?? s.deliverable,
            }));
            const activeStage = stages.find((s) => s.code === active) ?? stages[0];
            return (
              <>
                <div className="reveal is-visible" style={{ display: 'flex', justifyContent: 'center', margin: '32px 0' }}>
                  <MethodologyOrbit stages={stages.map((s) => ({ code: s.code, stage: s.stage }))} activeCode={activeStage?.code} maxWidth={620} onSelect={setActive} />
                </div>
                {activeStage && (
                  <div className="card reveal is-visible" style={{ maxWidth: 680, margin: '0 auto' }}>
                    <span className="eyebrow">
                      Stage {activeStage.n} of {stages.length}
                    </span>
                    <h2>{activeStage.stage}</h2>
                    <p className="body-lg">{activeStage.question}</p>
                    <p className="body-sm">
                      <strong>Deliverable:</strong> {activeStage.deliverable}
                    </p>
                  </div>
                )}
              </>
            );
          }}
        />
      </div>
    </section>
  );
}
